import React from "react";
import "./Scheme.css";
import purple_icon from "./../../../images/svg/purple-applications.svg";
import green_icon from "./../../../images/svg/green-applications.svg";
import red_icon from "./../../../images/svg/red-applications.svg";
import yellow_icon from "./../../../images/svg/yellow-applications.svg";
import grey_icon from "./../../../images/svg/grey-applications.svg";

function camelCaseToTitle(text) {
  return text
    .replace(/([A-Z])/g, ' $1')         // Add space before capital letters
    .replace(/^./, str => str.toUpperCase()); // Capitalize the first letter
}

const ApplicationCard = ({type, count, updatedcount}) => {
  return (
    <div className="app-card">
      <div className="app-card-header">
        <div className="app-card-text">
          <h3>{camelCaseToTitle(type)}</h3>
          <p className="app-count">{count}</p>
          <p className="app-delta"><span className="delta-positive">+{updatedcount}</span> from last month</p>
        </div>
        {type=="approved"?<img src={green_icon}/>
        :type=="pending"?<img src={yellow_icon}/>
        :type=="incomplete"?<img src={grey_icon}/>
        :type=="rejected"?<img src={red_icon}/>
        :<img src={purple_icon}/>
        }
        
      </div>
    </div>
  );
};

export default ApplicationCard;
